export const SHOW_TYPE_PARTNERSHIP_PRENOTAZIONI_SERVIZI = "partnership.prenotazioni_servizi";
export const SHOW_TYPE_PARTNERSHIP_PRENOTAZIONE_GRUPPI = "partnership.prenotazioni_gruppi";
export const SHOW_TYPE_PARTNERSHIP_ORDINI_FOOD = "partnership.ordini_food";
export const SHOW_TYPE_PARTNERSHIP_ORDINI_E_COMMERCE = "partnership.ordini_e_commerce";
export const SHOW_TYPE_PARTNERSHIP_HOMEPAGE = "partnership.homepage";